import React, { useState, useEffect } from "react"

// YouTube's privacy-enhanced domain defers cookie writes until playback starts
const toNoCookieDomain = url =>
  url
    .replace("www.youtube.com/embed", "www.youtube-nocookie.com/embed")
    .replace("//youtube.com/embed", "//www.youtube-nocookie.com/embed")

const Video = ({ videoSrcURL, videoTitle }) => {
  const [consent, setConsent] = useState(null)

  useEffect(() => {
    setConsent(localStorage.getItem("cookieConsent"))
  }, [])

  if (consent !== "accepted") {
    return (
      <div className="video video--blocked">
        <p>
          This video is hosted on YouTube. Accept cookies to watch it here.
        </p>
      </div>
    )
  }

  return (
    <div className="video">
      <iframe
        src={toNoCookieDomain(videoSrcURL)}
        title={videoTitle}
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        frameBorder="0"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        allowFullScreen
      />
    </div>
  )
}

export default Video
